import React from 'react'
import { TypeAnimation } from 'react-type-animation'
import ParticlesMain from './ParticlesMain'


const Guncelleniyor = () => {
  return (
    <div className='h-[calc(100vh-9rem)] bg-white flex justify-center items-center relative overflow-hidden'>
      <div className='absolute '>
      <TypeAnimation
        sequence={[

          `İçerik Güncelleniyor...`,
          1000

        ]}
        cursor={false}
        speed={1}
        className='text-[3.375rem] font-bold leading-none text-ulusOrange animate-changeOpacity1'
        style={{ fontSize: '3.375rem' }}

      />
      </div>


      <ParticlesMain />

    </div>
  )
}

export default Guncelleniyor